import { css } from "@emotion/react";
import TxtWithScroll from "../atoms/TxtWithScroll";

type Props = {
  staffFileName?: string;
  alt?: string;
  imgWidth?: number;
  txt: string;
  textBoxHeight?: number;
  isTop?: boolean;
  isBottom?: boolean;
};

const StaffInfo: React.FC<Props> = (props) => {
  const { staffFileName, alt, imgWidth, txt, textBoxHeight, isTop, isBottom } =
    props;
  return (
    <div css={mainStyle(isTop, isBottom)}>
      {staffFileName && (
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + `/img/${staffFileName}`}
          alt={alt}
          width={imgWidth || 140}
          css={imgStyle}
        />
      )}
      <div css={profileWrapperStyle}>
        <TxtWithScroll width={300} txt={txt} height={textBoxHeight} />
      </div>
    </div>
  );
};

const mainStyle = (isTop?: boolean, isBottom?: boolean) => css`
  width: 100%;
  margin-top: ${isTop ? "10px" : "30px"};
  margin-bottom: ${isBottom ? "30px" : "0px"};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const imgStyle = css`
  margin-top: 15px;
`;

const profileWrapperStyle = css`
  margin-top: 15px;
`;

export default StaffInfo;
